import { component } from "picoapp";
import { ProductForm, getUrlWithVariant } from "@shopify/theme-product-form";
import { formatMoney } from "@shopify/theme-currency";
import { serialize, getClosest } from "@utils";
import axios from "axios";

const selectors = {
  idInput: '[name="id"]',
  priceRange: "[data-price-range]",
  comparePrice: "[data-compare-price]",
  productPrice: "[data-product-price]",
  productSku: "[data-product-sku]",
  addToCart: "[data-add-to-cart]",
  variantSelectors: "[name*=options]",
};

class ProductFormComponent {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init();
    this.bindEvents();
    this.onOptionChange = this.onOptionChange.bind(this);
  }

  init() {
    // Cache DOM nodes
    this.productWrapper = getClosest(this.el, ".Product");
    this.formElement = this.el;
    this.idInput = document.querySelector(selectors.idInput);
    this.priceRangeEl = this.el.querySelector(selectors.priceRange);
    this.priceEl = this.el.querySelector(selectors.productPrice);
    this.addToCartEl = this.productWrapper.querySelector(selectors.addToCart);
    this.comparePriceEl = this.el.querySelector(selectors.comparePrice);
    this.variantSelectors = this.el.querySelectorAll(
      selectors.variantSelectors
    );
    this.gallery = document.querySelector(".Product__gallery");

    // Fetch variants info
    const productHandle = this.formElement.dataset.productHandle;
    fetch(`/products/${productHandle}.js`)
      .then((response) => {
        return response.json();
      })
      .then((productJSON) => {
        this.productForm = new ProductForm(this.formElement, productJSON, {
          onOptionChange: this.onOptionChange,
        });
      });
  }

  bindEvents() {
    this.formElement.addEventListener("submit", (e) => {
      this.addProductToCart(e);
    });
  }

  onOptionChange(event) {
    const variant = event.dataset.variant;
    let selectedVariant = this.productForm.variant();
    if (variant === null) {
      this.updateAtcButton(null);
      this.updateTextElements();
    } else if (variant && !variant.available) {
      this.updateAtcButton("unavailable", variant);
      if (this.priceRangeEl) {
        this.priceRangeEl.classList.add("u-hidden");
      }
      this.updateTextElements(selectedVariant);
    } else if (variant && variant.available) {
      if (this.priceRangeEl) {
        this.priceRangeEl.classList.add("u-hidden");
      }
      this.updateAtcButton("addToCart", variant);

      this.updateTextElements(selectedVariant);
    }

    if (variant !== null) {
      const url = getUrlWithVariant(window.location.href, variant.id);
      window.history.replaceState({ path: url }, "", url);
      this.idInput.value = variant.id;
      this.updateFeaturedImage(selectedVariant);
    }
  }

  updateAtcButton(val, variant) {
    if (val && variant) {
      this.addToCartEl.querySelector("[data-add-to-cart-text]").innerHTML =
        theme.strings[val];
    } else {
      this.addToCartEl.querySelector("[data-add-to-cart-text]").innerHTML =
        "Choose Options";
    }

    switch (val) {
      case "soldOut":
        this.addToCartEl.disabled = true;
        break;
      case "addToCart":
        this.addToCartEl.disabled = false;
        break;
      default:
        this.addToCartEl.disabled = true;
        break;
    }
  }

  updateFeaturedImage(variant) {
    if (variant && this.gallery) {
      const variantUpdated = new CustomEvent("variant-updated", {
        detail: {
          variant: variant,
        },
      });
      this.gallery.dispatchEvent(variantUpdated);
    }
  }
  updateTextElements(variant) {
    if (variant) {
      this.priceEl.classList.remove("u-hidden");
      this.priceEl.innerText = formatMoney(variant.price);
    }

    if (variant && this.comparePriceEl) {
      this.comparePriceEl.classList.remove("u-hidden");
    }

    if (variant && this.comparePriceEl) {
      if (variant.price < variant.compare_at_price) {
        this.comparePriceEl.style.display = "inline-block";
        this.comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
      } else {
        this.comparePriceEl.style.display = "none";
      }
    }
  }

  addProductToCart(ev) {
    ev.preventDefault();
    this.addToCartEl.querySelector("[data-add-to-cart-text]").innerHTML =
      "Adding";
    const formData = serialize(this.el);

    axios
      .post("/cart/add.js", formData)
      .then((response) => {
        this.ctx.emit("cart.update");
        // Redirect to checkout depending on element dataset properties
        //if (this.successAction && this.successAction == 'redirect') {
        //  window.location.replace(window.location.origin + '/checkout');
        //}
      })
      .then(() => {
        this.addToCartEl.querySelector("[data-add-to-cart-text]").innerHTML =
          "Added";
        this.addToCartEl.disabled = true;
        setTimeout(() => {
          this.addToCartEl.querySelector("[data-add-to-cart-text]").innerHTML =
            "Add To Cart";
          this.addToCartEl.disabled = false;
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default component((node, ctx) => {
  new ProductFormComponent(node, ctx);
});
